import { isEmpty } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import turf from '@turf/turf';
import { getWaypointList } from '../../api/Missions/mission-operations';
import { pointsCollectionFeatureToLineString } from '../geojson-utilities';
import { getLandingPoint } from '../waypoint-utilities';

/**
 * With the new end point and the leaflet layer, draws the landing bearing on the map,
 * clearing the layer first.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after creating a the landing bearing.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables
 * needed from the map component.
 */
const drawLandingBearing = ({ toPoint, getCurrentMapState }) => {
  const { mission, landingBearingLayer } = getCurrentMapState();
  const waypointList = getWaypointList(mission);
  if (!isEmpty(waypointList)) {
    const landingPoint = getLandingPoint(waypointList);
    const landingBearingFeatureColec = turf.featureCollection([landingPoint, toPoint]);
    const landingBearingLineString = pointsCollectionFeatureToLineString(
      landingBearingFeatureColec
    );

    landingBearingLayer.clearLayers();
    landingBearingLayer.addData(landingBearingLineString);
    return landingBearingLineString;
  }
  Bert.alert('There is no waypoint list', 'warning');
  return {};
};

export default drawLandingBearing;
